module.exports = __webpack_public_path__ + "img/ic-map-blue.28041d11.svg";